<script>
import { computed } from '@vue/runtime-core';
import { useRoute } from "vue-router";
import { useStore } from 'vuex';
export default {

    setup(){
        const route = useRoute();
        const store  = useStore();

        const year = route.params.year;
        const data = computed(() => store.getters.student);
        return {year,data};
    }
}
</script>

<template>
    <div v-for="item in data" :key="item.year">
        <div v-if="item.year === year" class="main">
            <div class="group" v-for="t in item.topic" :key="t.title">
                <div class="data">
                        <div class="label">主題</div>
                        <div class="title">{{t.title}}</div>
                        <div class="label">成員</div>
                        <div class="member" v-for="m in t.member" :key="m">
                            {{m}}
                        </div>  
                </div>
                 <img :src=t.picture :alt=item.topic.title class="img">
            </div> 
        </div>
        <br/>
    </div>
</template>

<style lang="scss" scoped>

.group{
    margin-right: 30%;
    margin-left: 30%;
    display: flex;
    margin-top: 1%;
    padding-block-start: 0.2%;
    padding-block-end: 0.2%;
    border-radius: 15px;
    font-size: 20px;
    color: #fff;
    background-color: #4169E1;
    >.data{
        width: 30%;
        >.label{
            width: 40%;
            border-radius: 15px;
            margin: 3%;
            text-align: center;
            background-color:  #B399FF;
        }
        >.title{
            margin-left: 5%;
            margin-bottom: 5%;
            margin-top: 5%;
        }
        >.member{
            margin-left: 10%;
            margin-bottom: 5%;
            margin-top: 5%;
        }
    }
    >.img{
        margin: 1% 1% 1% 3%;
        width: 40%;
    }
    
}

</style>